import React from 'react';
import styled from 'styled-components';
import { themeV2 } from '../styles/themeV2';

const StyledCard = styled.div`
  background: ${themeV2.colors.white};
  border: 1px solid ${themeV2.colors.slate[200]};
  border-radius: ${themeV2.borderRadius['2xl']};
  padding: ${themeV2.spacing['2xl']};
  box-shadow: ${themeV2.shadows.sm};
  transition: all 0.2s ease;
  
  &:hover {
    box-shadow: ${themeV2.shadows.md};
  }
`;

const IconContainer = styled.div`
  width: ${props => props.size === 'large' ? '3rem' : '2.5rem'};
  height: ${props => props.size === 'large' ? '3rem' : '2.5rem'};
  display: grid;
  place-items: center;
  border-radius: ${themeV2.borderRadius['2xl']};
  background: ${themeV2.colors.slate[100]};
  margin-bottom: ${themeV2.spacing.lg};
  
  svg {
    width: ${props => props.size === 'large' ? '1.5rem' : '1.25rem'};
    height: ${props => props.size === 'large' ? '1.5rem' : '1.25rem'};
    color: ${themeV2.colors.slate[700]};
  }
`;

const Title = styled.h3`
  font-size: ${props => props.size === 'large' ? themeV2.typography.fontSize.xl : themeV2.typography.fontSize.lg};
  font-weight: ${themeV2.typography.fontWeight.semibold};
  color: ${themeV2.colors.slate[900]};
  margin: 0 0 ${themeV2.spacing.sm} 0;
  line-height: ${themeV2.typography.lineHeight.tight};
`;

const Description = styled.p`
  font-size: ${themeV2.typography.fontSize.sm};
  color: ${themeV2.colors.slate[600]};
  margin: 0;
  line-height: ${themeV2.typography.lineHeight.normal};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${themeV2.spacing.md};
`;

const CardV2 = ({ 
  icon, 
  title, 
  description, 
  children, 
  size = 'medium',
  className,
  ...props 
}) => {
  return (
    <StyledCard className={className} {...props}>
      {icon && (
        <IconContainer size={size}>
          {icon}
        </IconContainer>
      )}
      
      <Content>
        {title && <Title size={size}>{title}</Title>}
        {description && <Description>{description}</Description>}
        {children}
      </Content>
    </StyledCard>
  );
};

export default CardV2;